import { render, staticRenderFns } from "./Fare.vue?vue&type=template&id=bba3970c&scoped=true&"
import script from "./Fare.vue?vue&type=script&lang=js&"
export * from "./Fare.vue?vue&type=script&lang=js&"
import style0 from "./Fare.vue?vue&type=style&index=0&id=bba3970c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba3970c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
